exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container[data-v-34963551]{padding-top:80px;padding-left:8px;padding-right:8px;text-align:left}", "", {"version":3,"sources":["/Users/tony/Desktop/projects/woods/src/components/Privacy.vue"],"names":[],"mappings":"AAuJA,4BACE,iBAAkB,AAClB,iBAAkB,AAClB,kBAAmB,AACnB,eAAiB,CAClB","file":"Privacy.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*styles for smaller screens*/\n.container[data-v-34963551] {\n  padding-top: 80px;\n  padding-left: 8px;\n  padding-right: 8px;\n  text-align: left;\n}\n@media (max-width: 767px) {\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34963551","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Privacy.vue
// module id = 302
// module chunks = 1